export default class BackofficeStudyRequestImportsStats {
    constructor() {
        // Initialize stats page if needed
    }

    onDestroy() {
        // Cleanup if needed
    }
}
